import { ConversationResponse } from '@fp/interfaces/conversational/generated/model/conversation-response';
import { CreateConversationRequest } from '@fp/interfaces/conversational/generated/model/create-conversation-request';
import { ConversationMapper } from '@klant/conversational-connector/mappers/conversation-mapper/conversation.mapper';
import { ConversationModel } from '@klant/conversational-connector/models/Conversation.model';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConversationSessionDetails } from '../../../../session-storage/session-storage.model';
import { SessionStorageService } from '../../../../session-storage/session-storage.service';
import { ConversationalConfigStore } from '../../../../signal-stores/conversational-config-store/conversational-config.store';
import { ChatSession, LoginStatus } from '../../klant-conversational-connector.model';

@Injectable({ providedIn: 'root' })
export class ConversationService {
    private readonly conversationalConfigStore = inject(ConversationalConfigStore);
    private readonly httpClient = inject(HttpClient);
    private readonly sessionStorageService = inject(SessionStorageService);

    public createConversation(conversationsLink: string, chatSession: ChatSession): Observable<ConversationModel> {
        let createConversationRequest: CreateConversationRequest = {};

        if (chatSession.loginStatus === LoginStatus.LOGGED_IN) {
            createConversationRequest.token = chatSession.token;
        }

        return this.httpClient
            .post<ConversationResponse>(`${this.conversationalConfigStore.basePath()}${conversationsLink}`, createConversationRequest)
            .pipe(map((conversationResponse) => ConversationMapper.mapConversationResponseToConversationModel(conversationResponse)));
    }

    public getConversation(): Observable<ConversationModel> {
        const conversationSessionDetails: ConversationSessionDetails = this.sessionStorageService.getConversationSessionDetails();
        if (!conversationSessionDetails) {
            return throwError(() => new Error('No conversation session details available'));
        }

        const conversationLink = conversationSessionDetails.conversationLink;
        const httpHeaderAuthorization = `Bearer ${conversationSessionDetails.accessToken}`;
        const headers = new HttpHeaders().append('Authorization', httpHeaderAuthorization);

        return this.httpClient
            .get<ConversationResponse>(`${this.conversationalConfigStore.basePath()}${conversationLink}`, { headers })
            .pipe(map((conversationResponse) => ConversationMapper.mapConversationResponseToConversationModel(conversationResponse)));
    }
}
